import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import Step from '../../../../../../../features/components/Forms/StepForm/Step'
import ImageOptions from './ImageOptions'
import VideoOptions from './VideoOptions'

import { AD_TYPE_VIDEO } from '../../fields'

const AdCreateRouteSelector = ({ manageStepFormRoutes, handleStepChange, adType }) => {
  const { t } = useTranslation()

  const { selectedRoute, handleSelectRoute, routeWasSelected } = manageStepFormRoutes
  // chooseRoute just handle the UI and selectedRoute manage actual route
  const [chooseRoute, setChooseRoute] = useState(selectedRoute)

  const handleContinue = () => {
    if (selectedRoute === chooseRoute) {
      // route wasn't change
      handleStepChange()
    } else {
      // selected new route
      handleSelectRoute(chooseRoute)
    }
  }

  useEffect(() => {
    routeWasSelected && handleStepChange()
    // eslint-disable-next-line
  }, [])

  // The answers to this question will define which route the user takes (Route A, Route B or Route C)
  return (
    <Step stepTitle={t('Which type of ad do you want to create?')} handleContinue={handleContinue}>
      {adType === AD_TYPE_VIDEO ? (
        <VideoOptions chooseRoute={chooseRoute} setChooseRoute={setChooseRoute} />
      ) : (
        <ImageOptions chooseRoute={chooseRoute} setChooseRoute={setChooseRoute} />
      )}
    </Step>
  )
}

export default AdCreateRouteSelector
